import { useState } from "react";
import { PageLayout } from "@/components/PageLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { getCalculatorSEO } from "@/hooks/useSEO";

export default function DateDifferenceCalculator() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [results, setResults] = useState<any>(null);

  const calculateDifference = () => {
    if (!startDate || !endDate) return;
    
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end.getTime() - start.getTime());
    
    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30.44);
    const years = Math.floor(days / 365.25);
    
    setResults({
      days,
      weeks,
      months,
      years,
      hours: Math.floor(diffTime / (1000 * 60 * 60)),
      minutes: Math.floor(diffTime / (1000 * 60))
    });
  };

  return (
    <PageLayout calculatorName="Date Difference Calculator" calculatorPath="/calculator/date-difference">
      <div className="grid gap-8 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Calculate Date Difference</CardTitle>
            <CardDescription>Select two dates</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Start Date</Label>
              <Input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div>
              <Label>End Date</Label>
              <Input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <Button onClick={calculateDifference} className="w-full">
              Calculate Difference
            </Button>
          </CardContent>
        </Card>

        {results && (
          <Card>
            <CardHeader>
              <CardTitle>Time Difference</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex justify-between text-lg">
                <span>Years:</span>
                <span className="font-semibold">{results.years}</span>
              </div>
              <div className="flex justify-between text-lg">
                <span>Months:</span>
                <span className="font-semibold">{results.months}</span>
              </div>
              <div className="flex justify-between text-lg">
                <span>Weeks:</span>
                <span className="font-semibold">{results.weeks}</span>
              </div>
              <div className="flex justify-between text-lg border-t pt-3">
                <span>Days:</span>
                <span className="font-semibold text-primary">{results.days}</span>
              </div>
              <div className="flex justify-between text-sm text-muted-foreground">
                <span>Hours:</span>
                <span>{results.hours.toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-sm text-muted-foreground">
                <span>Minutes:</span>
                <span>{results.minutes.toLocaleString()}</span>
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </PageLayout>
  );
}
